// @flow

export type TlsProductSummary = {
  name: string,
  amount: number,
  contractValidityStart: ?Date,
  contractValidityEnd: ?Date,
  productOwnerName: string,
  retailerName: string,
  productSaleDate: ?Date
}

const buildTlsProductSummary = (name: string): TlsProductSummary => {
  return {
    name: name,
    amount: 0,
    contractValidityStart: null,
    contractValidityEnd: null,
    productOwnerName: '',
    retailerName: '',
    productSaleDate: null
  }
}

export {
  buildTlsProductSummary
}



// WEBPACK FOOTER //
// ./src/types/tls-product-summary.js